/** Version du frontend actuellement servi (le client la retient aussi via l'en-tête `X-App-Version`). */
import { apiGet } from './client';

export function getServedAppVersion(): Promise<{ version: string | null }> {
  return apiGet<{ version: string | null }>('/api/version');
}
